import React from "react";
import { useDispatch } from "react-redux";
import Axios from "axios";
import { cargarNotaria } from '../../actions/notariaAction';
import CotizadorCore from "components/Cotizador/CotizadorCore.js";

function CotizadorW() {
  const dispatch = useDispatch();
  const [servicios, setServicios] = React.useState([]);

  React.useEffect(() => {
    const consultar = async () => {
      const config = { headers: { Authorization: "Bearer " + process.env.REACT_APP_TOKEN_API } };
      const resultado = await Axios.get(process.env.REACT_APP_UrlApi + 'notaria', config);
      if (resultado.status === 200) {
        let dataTemp = {};
        resultado.data.forEach((e) => { dataTemp[e.variable] = e.value; });
        dispatch(cargarNotaria(dataTemp));
      }
    };
    consultar();
  }, []);

  React.useEffect(() => {
    const consultarServicios = async () => {
      const config = { headers: { Authorization: "Bearer " + process.env.REACT_APP_TOKEN_API } };
      const resultado = await Axios.get(process.env.REACT_APP_UrlApi + "configCotizador", config);
      setServicios(resultado.data);
    };
    consultarServicios();
  }, []);

  const onCotizar = (payload) => Axios.post(
    process.env.REACT_APP_UrlApi + "cotizador/cotizar",
    payload,
    { headers: { Authorization: "Bearer " + process.env.REACT_APP_TOKEN_API } }
  );

  return <CotizadorCore onCotizar={onCotizar} serviciosIniciales={servicios} />;
}

export default CotizadorW;